export const NAVIGATE_TO_COURSE = "NAVIGATE_TO_COURSE"
